import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location.pathname }), [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-50" data-testid="admin-loading">
        <Loader2 className="w-6 h-6 text-emerald-600 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={redirectState} replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
